import React, { useState, useEffect } from 'react';
import { TCreateSideMenu } from '../../components/HeaderComponent/HeaderComponent';
import { PathUtils } from '@adobe/aem-spa-page-model-manager';
import { useWidthContext } from '../Width';
import SideMenu from './SideMenu/SideMenu';
interface IChildren {
    children: React.ReactNode;
}

export interface ISideMenuContextValue {
    hamburgerOpen: boolean;
    setHamburgerOpen: React.Dispatch<React.SetStateAction<boolean>>;
    hamburgerSide: 'left' | 'right',
    setHamburgerSide: React.Dispatch<React.SetStateAction<String>>,
    hamburgerContainer: TCreateSideMenu;
    setHamburgerContainer: React.Dispatch<React.SetStateAction<TCreateSideMenu>>;
}

export const SideMenuContext = React.createContext<ISideMenuContextValue>({
    hamburgerOpen: false,
    setHamburgerOpen: () => { },
    hamburgerSide: 'right',
    setHamburgerSide: () => { },
    hamburgerContainer: { title: '' },
    setHamburgerContainer: () => { },
});


export const SideMenuProvider = (props: IChildren) => {
    const { width } = useWidthContext();
    const [hamburgerOpen, setHamburgerOpen] = useState<boolean>(false);
    const [hamburgerSide, setHamburgerSide] = useState<'left' | 'right'>(width > 768 ? 'right' : 'left');
    const [hamburgerContainer, setHamburgerContainer] = useState<TCreateSideMenu>({ title: '' });
    const sideMenuToggle = PathUtils.getMetaPropertyValue('hideSideMenuToggle') === 'true';
    const pageElement = document.querySelector('.aem-page-container') as HTMLElement;

    useEffect(() => {
        let lastWidth = window.innerWidth;

        const handleResize = () => {
            const currentWidth = window.innerWidth;
            if (currentWidth !== lastWidth && hamburgerOpen) {
                setHamburgerOpen(false);
            }
            lastWidth = currentWidth;
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [hamburgerOpen]);

    useEffect(() => {
        if (width > 768) {
            setHamburgerSide('right');
        } else {
            setHamburgerSide('left');
        }
    }, [width]);

    return (
        <SideMenuContext.Provider value={{ hamburgerOpen, setHamburgerOpen, hamburgerSide, setHamburgerSide, setHamburgerContainer, hamburgerContainer }}>
            {!sideMenuToggle && <SideMenu open={hamburgerOpen} setOpen={setHamburgerOpen} side={hamburgerSide} createSideMenu={hamburgerContainer} freeze={true} pageElement={pageElement}/>}
            {props.children}
        </SideMenuContext.Provider>
    );
};